'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dPolicy$002dPage from "./presto.-Edit-Policy-Page.js";
var $p;
/** @constructor */
function $c_Lpresto_EditPolicyPage$() {
}
export { $c_Lpresto_EditPolicyPage$ as $c_Lpresto_EditPolicyPage$ };
$p = $c_Lpresto_EditPolicyPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_EditPolicyPage$;
/** @constructor */
function $h_Lpresto_EditPolicyPage$() {
}
export { $h_Lpresto_EditPolicyPage$ as $h_Lpresto_EditPolicyPage$ };
$h_Lpresto_EditPolicyPage$.prototype = $p;
$p.l = (function() {
  return "EditPolicyPage";
});
$p.cFY = (function(x$0) {
  return new $j_presto$002e$002dEdit$002dPolicy$002dPage.$c_Lpresto_EditPolicyPage(x$0.j(0));
});
var $d_Lpresto_EditPolicyPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_EditPolicyPage$, "presto.EditPolicyPage$", ({
  I2: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_EditPolicyPage$ as $d_Lpresto_EditPolicyPage$ };
var $n_Lpresto_EditPolicyPage$;
function $m_Lpresto_EditPolicyPage$() {
  if ((!$n_Lpresto_EditPolicyPage$)) {
    $n_Lpresto_EditPolicyPage$ = new $c_Lpresto_EditPolicyPage$();
  }
  return $n_Lpresto_EditPolicyPage$;
}
export { $m_Lpresto_EditPolicyPage$ as $m_Lpresto_EditPolicyPage$ };
//# sourceMappingURL=presto.-Edit-Policy-Page$.js.map
